<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='popup-named-router'>
  <div class='popup-content'>
    <button bsButton class='close' [rounded]="true" [text]="true" [size]="'large'"
            (click)='close()' data-testid="close-btn"><span class="fa-solid fa-xmark" bsButtonIcon></span></button>

    <router-outlet></router-outlet>
  </div>
</div>


